<template>
  <div class="appHeader">
    <div class="appHeaderNavChoice">
      <input type="button" value="Retour" class="appButtonModelNav" onclick="history.go(-1)">
    </div>
    <div class="appHeaderNavChoice">
      <img src="../../assets/Logo1.png" alt="logo de Privilégia Coiffure" class="appLogoPrivilegiaMini" />
    </div>
    <div class="appHeaderNavChoice">
      <button @click.prevent="goHome()" type="submit" class="appButtonModelNav">Home</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderApp',
  data () {
    return {
    }
  },
  methods: {
    goHome () {
      localStorage.removeItem('orderPrivilegia')
      localStorage.removeItem('orderPrivilegiaSettings')
      this.$router.push('/App/Home')
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/HeaderApp.vue